import { z } from 'zod';
import { NotifySendAttemptCommunicationTypeSchema } from '../inputTypeSchemas/NotifySendAttemptCommunicationTypeSchema'

/////////////////////////////////////////
// NOTIFY SEND ATTEMPT SCHEMA
/////////////////////////////////////////

export const NotifySendAttemptSchema = z.object({
  communicationType: NotifySendAttemptCommunicationTypeSchema,
  coreCommunicationSendAttemptId: z.number().int(),
  massNotificationId: z.number().int().nullable(),
  subscriberContactMethodId: z.number().int().nullable(),
})

export type NotifySendAttempt = z.infer<typeof NotifySendAttemptSchema>

export default NotifySendAttemptSchema;
